import { useUserContext } from "@/context/user";
import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Search } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { Button } from "../ui/button";
const MultiSelectFilter = ({
  list,
  selected,
  setQuery,
  labelKey,
  title,
}: {
  list: {
    label: string;
    count?: string | number;
  }[];
  selected: string[];
  setQuery: (query: any) => void;
  labelKey: string;
  title: string;
}) => {
  const { me } = useUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  const addCategory = (label: string) => {
    const updated = [...(selected || []), label];
    setQuery({
      [labelKey]: updated.length > 0 ? updated : undefined,
    });
  };

  const removeCategory = (label: string) => {
    const updated = selected.filter((name: string) => name !== label);
    setQuery({
      [labelKey]: updated.length > 0 ? updated : undefined,
    });
  };

  console.log(list);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="none"
          className="px-5 py-3 border-[#e8e8e8] text-[#696969] text-sm rounded-full shadow-none"
        >
          {title}
          {isOpen ? (
            <svg
              className="ml-2 rotate-180"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.66797 5.32007L8.03464 11.6801L14.3346 5.38007"
                stroke="#1D1D1D"
                strokeMiterlimit="10"
              />
            </svg>
          ) : (
            <svg
              className="ml-2"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.66797 5.32007L8.03464 11.6801L14.3346 5.38007"
                stroke="#1D1D1D"
                strokeMiterlimit="10"
              />
            </svg>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[300px] p-0 font-normal font-sh5 rounded-none border border-solid border-[#e5e5e5]"
        align="start"
      >
        {list?.length > 0 ? (
          <>
            <div className="px-[28px] py-6">
              {/* Search box */}
              <div className="relative">
                <Search className="absolute left-[22px] top-2.5 h-4 w-4 text-gray-100" />
                <input
                  type="text"
                  placeholder="Search artists name"
                  className="w-full py-[10px] pl-11 pr-4 text-sm border border-solid rounded-full border-gray-20 text-gray-60"
                  value={searchTerm}
                  onChange={(e) => handleSearch(e)}
                />
              </div>
            </div>
            {/* List categories */}
            <div className="overflow-auto max-h-60">
              {list
                ?.sort(
                  (
                    a: { label: string; count?: string | number },
                    b: { label: string; count?: string | number }
                  ) => {
                    return a?.label?.localeCompare(b.label);
                  }
                )
                .map((category: { label: string; count?: string | number }) => (
                  <label
                    key={category.label}
                    className="flex items-center cursor-pointer hover:bg-gray-10 gap-x-3 text-gray-60 mb-[20px] text-base px-[28px]"
                  >
                    <Checkbox
                      id={category.label}
                      className="w-5 h-5"
                      checked={selected?.includes(category.label)}
                      onCheckedChange={(checked: boolean) => {
                        if (checked) {
                          addCategory(category.label);
                        } else {
                          removeCategory(category.label);
                        }
                      }}
                    />
                    <p>
                      <span>{category.label}</span>
                      {category.count && (
                        <span className="ml-1">({category.count})</span>
                      )}
                    </p>
                  </label>
                ))}
            </div>
          </>
        ) : (
          <div>no data</div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default MultiSelectFilter;
